import * as React from 'react';
import { withRouter } from 'react-router';
import { WithRouterProps } from '../../../../node_modules/@types/react-router';

import { Link } from 'react-router';

import TopNavigationMenuItem from '../../../api/topNavigationMenuEntity';

interface IProps {
  topNavigationMenu: { topNavigationMenuItems: TopNavigationMenuItem[], isMobileNavigationVisible: boolean };
  fetchTopNavigationMenuItems(): void;
  toggleMobileNavigationMenu(): void;
  updateTopNavigationMenuItemState(subMmenuItem: TopNavigationMenuItem): void;
}

export class TopNavigationMenu extends React.Component<IProps,{}> {
  public componentDidMount() {
    this.props.fetchTopNavigationMenuItems();
  }

  public render() {
    const buttonClassName = this.props.topNavigationMenu.isMobileNavigationVisible === true ? "toggle-sm-visibility nav-wrap hid-sm" : "toggle-sm-visibility nav-wrap hid-sm hid"
    const mainButtonClassName = this.props.topNavigationMenu.isMobileNavigationVisible === true ? "hidden-md hidden-lg toggle_next toggle_main_menu open" : "hidden-md hidden-lg toggle_next toggle_main_menu"

    return (
      <div className="main-nav">
      <button className={mainButtonClassName} onClick = { this.props.toggleMobileNavigationMenu }>
			    <span />
				  <span />
				  <span />
				  <span />
				</button>
        <div className={buttonClassName}>
            <div className="container">
                <nav>
                    <div className="mddm-wrap clearfix">
                        <ul className="mddm">
                            {this.props.topNavigationMenu.topNavigationMenuItems &&
                              this.props.topNavigationMenu.topNavigationMenuItems.map(item => TopNavigationMenuItemRow(item, this.props))}
                        </ul>
                    </div>
                </nav>
            </div>
        </div>
      </div>
    );
  }
};

const TopNavigationMenuItemRow = (topNavigationMenuItem: TopNavigationMenuItem, props: IProps): any => {
  const buttonClassName = topNavigationMenuItem.isExpanded ? "hidden-md-up toggle_next toggler open" : "hidden-md-up toggle_next toggler";
  const divClassName = topNavigationMenuItem.isExpanded ? "row toggle-sm-visibility" : "row toggle-sm-visibility hid";

  const handleSubMenuItemClick = (history: WithRouterProps) => {
    if (topNavigationMenuItem.subMenuItems.length !== 0) {
     props.updateTopNavigationMenuItemState(topNavigationMenuItem);
    } else {
      history.router.push(topNavigationMenuItem.linkUrl);
      props.toggleMobileNavigationMenu();
    }
  }

  // const SubMenuItemButton = () => {
  //   return (<button className={buttonClassName} onClick={handleSubMenuItemClick}><span className="sr-only">{topNavigationMenuItem.linkText}</span></button>);
  // }

  const SubMenuItemButtonWithRouter = () => {
    const Button = withRouter((history) => (
      <button className={buttonClassName} onClick={handleSubMenuItemClick.bind(handleSubMenuItemClick, history)}><span className="sr-only">{topNavigationMenuItem.linkText}</span></button>
    ));

    return <Button />;
  }

  const LinkItemWithRouter = () => {

    const handleMenuItemClick = (history: WithRouterProps) => {
      props.toggleMobileNavigationMenu()
    }

    let LinkItem;

    if (topNavigationMenuItem.linkUrl && !topNavigationMenuItem.linkUrl.startsWith("http")) {
      LinkItem = withRouter((history) => (
        <Link target={topNavigationMenuItem.urlTarget} to={`${topNavigationMenuItem.linkUrl}`} onClick={handleMenuItemClick.bind(handleMenuItemClick, history)}>
            {topNavigationMenuItem.linkText}
          </Link>
      ));
  } else {
    LinkItem = withRouter((history) => (
      <a href={topNavigationMenuItem.linkUrl} target={topNavigationMenuItem.urlTarget}>
          {topNavigationMenuItem.linkText}
      </a>
    ));
  }
    return <LinkItem />;
  }

  return (
    <li className={topNavigationMenuItem.additionalCssClass}>
        <LinkItemWithRouter />
        {topNavigationMenuItem.subMenuItems.length !== 0 &&
          <React.Fragment>
          <SubMenuItemButtonWithRouter />
          <div className={divClassName}>
            <div className="col-md-12"><ul>{topNavigationMenuItem.subMenuItems.map(item => TopNavigationMenuItemRow(item, props))}</ul>
            </div>
          </div>
          </React.Fragment>
        }
    </li>
  )
}


// WEBPACK FOOTER //
// ./src/common/components/topNavigation/topNavigation.tsx